import AdiaLive5DBAccessor from "./adiaLive5DBAccessor";

export default class AdiaLive5StreamRecorder{
	constructor(options){
		this.dbName = 'al5RecorderDB';
		this.objectStoreName = options.objectStoreName;

		this.meetingId = options.meetingId;
		this.userId = options.userId;

		this.stream = options.stream;
		this.mediaType = options.mediaType;
		this.audioBitRate = options.audioBitRate;
		this.videoBitRate = options.videoBitRate;

		this.mediaRecorder = null;
		this.startedSuccessfully = false;

		this.startTime = 0;
		this.chunks = 0;
		this.savedChunks = 0;

		this.onRecordingStopped = options.onRecordingStopped;
		this.onRecordingSaved = options.onRecordingSaved;
		this.onError = options.onError;

		this.dbAccessor = new AdiaLive5DBAccessor();
		this.recorderReadyPromise = this.dbAccessor.init(this.dbName, options.objectStoreName);
	}

	startRecording(){
		if(this.mediaRecorder){
			return Promise.resolve();
		}

		const _this = this;

		return new Promise(function (resolve, reject) {
			const mimeType = (_this.mediaType === 'audio') ? 'audio/webm' : 'video/webm';

			const audBitRate = (typeof _this.audioBitRate === 'number') ? Math.round(_this.audioBitRate) : 128000;
			const vidBitRate = (typeof _this.videoBitRate === 'number') ? Math.round(_this.videoBitRate) : 2000000;

			const options = {
				audioBitsPerSecond: audBitRate,
				videoBitsPerSecond: vidBitRate,
				mimeType: mimeType
			};

			_this.mediaRecorder = new MediaRecorder(_this.stream, options);
			_this.mediaRecorder.ondataavailable = function(event) {
				if(event.data.size > 0) {
					_this.chunks++;

					const entry = {
						meetingId: _this.meetingId,
						userId: _this.userId,
						start: _this.startTime,
						saved: Date.now(),
						blob: event.data
					};

					_this.dbAccessor.add(entry)
					.then(function(result) {
						_this.savedChunks++;
					});
				}
			};

			_this.mediaRecorder.onstop = function() {
				_this.mediaRecorder = null;
			};

			_this.mediaRecorder.onstart = function() {
				_this.startedSuccessfully = true;

				resolve('Started successfully')
			}

			_this.mediaRecorder.onerror = function(error) {
				_this.mediaRecorder = null;

				if(_this.startedSuccessfully) {
					_this.onError(error)
				}
				else {
					reject(error);
				}
			}

			// Start-up
			_this.recorderReadyPromise
			.then(function() {
				_this.startTime = Date.now();

				_this.mediaRecorder.start(15 * 1000);    // Time between flushes in ms, currently 15 seconds

			})
			.catch(function(ex) {
				reject(ex);
			});
		})
	}

	stopRecording(){
		if(this.mediaRecorder && this.mediaRecorder.state != 'inactive'){
			this.mediaRecorder.stop();		// Media recorder is nulled in onstop event
		}
	};

	getIsRecording(){
		return !!this.mediaRecorder;
	}
}